export const SPORT_SELECTOR_INPUT_LABEL = "Sport Filter";
export const DEFAULT_DROPDOWN_ITEM = "None";



// WEBPACK FOOTER //
// ./src/features/director/pages/dashboard/components/advanced-filters/components/sport-filter/constants.ts